import { fileNameFromDisposition, pdfQuery, type PdfOptions, unwrap } from '@lista/app-core';
import i18n from 'i18next';
import { api } from '../client';

/** Browser download of the server-rendered PDF (the API renders it through IPdfGenerator). */
export const exportService = {
  async pdf(
    listId: string,
    options: Omit<PdfOptions, 'locale' | 'timeZone'> = {},
  ): Promise<{ blob: Blob; fileName: string }> {
    let disposition: string | null = null;
    const blob = await unwrap(
      api
        .GET('/lists/{id}/pdf', {
          params: {
            path: { id: listId },
            query: pdfQuery({
              paper: navigator.language.endsWith('US') ? 'LETTER' : 'A4',
              ...options,
              locale: i18n.language === 'ar' ? 'ar' : 'en',
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }) as never,
          },
          parseAs: 'blob',
        })
        .then((r) => {
          disposition = r.response.headers.get('Content-Disposition');
          return r;
        }),
    );
    return {
      blob: blob as unknown as Blob,
      fileName: fileNameFromDisposition(disposition, 'list.pdf'),
    };
  },
};
